module.exports = __webpack_public_path__ + "img/sec1.abcb553c.png";